<template>
  <button class="header-section back-button btn-primary" @click.capture="goBack">
    <fluent-icon icon="chevron-left" />
    {{ buttonLabel || $t('GENERAL_SETTINGS.BACK') }}
  </button>
</template>
<script>
import router from '../../routes/index';

export default {
  props: {
    backUrl: {
      type: [String, Object],
      default: '',
    },
    buttonLabel: {
      type: String,
      default: '',
    },
    isTicket: {
      default:  false,
      type: Boolean,
    },
  },
  methods: {
    goBack() {
      if(this.isTicket){
        this.$emit('close-modal-ticket', false);
        return;
      }

      if (this.backUrl !== '') {
        router.push(this.backUrl);
      } else {
        router.go(-1);
      }
    },
  },
};
</script>
